import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { ListData, ListFilter, sortList, Record } from '../../models/List.MenuCategories';
import { RestaurantDetails } from '../../models/List.Restaurant';
import { MenuCategoryService } from '../../services/MenuCategories.service';
import { RestaurantService } from '../../services/Restaurant.service';
import { MenuCategoriesFormComponent } from './menu-categories-form/menu-categories-form.component';

@Component({
  selector: 'app-menu-categories',
  templateUrl: './menu-categories.component.html'
})
export class MenuCategoriesComponent implements OnInit {

  dataLoading = true;
  showFilter = false;
  showSearch = false;

  restaurantName?: string;
  allRestaurants: RestaurantDetails[] = [];
  sortItems = [
    { name: this.translate.instant('content.Name'), value: sortList.Name },
    { name: this.translate.instant('forms.Recently added'), value: sortList.NewestCreate },
    { name: this.translate.instant('content.Oldest added'), value: sortList.OldestCreate },
    { name: this.translate.instant('menu.Highest number of Use'), value: sortList.HighestUse },
    { name: this.translate.instant('menu.Lowest number of Use'), value: sortList.LowestUse },
  ];

  pageIndex = 0;
  pageCount = 0;
  pageSize = 8;
  recordsData!: ListData | null;
  filterModel: ListFilter = new ListFilter();

  filterFormGroup: FormGroup = new FormGroup({});
  today = new Date();

  // Restaurant ID
  restaurantId?: any;
  sortItemSelected?: any;
  restaurantIdParam!: any;
  restaurantData: any;
  lang = localStorage.getItem('language') || 'en';

  subscriptions: Subscription[] = []
  isProfile!: any
  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public translate: TranslateService,
    private service: MenuCategoryService,
    private formBuilder: FormBuilder,
    private restaurantService: RestaurantService,
    private router: Router) {
    // this.route.params.subscribe(params => {
    //   this.restaurantIdParam = params['id'];
    // });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['isProfile']) {
        this.isProfile = [params['isProfile']];
      }
    });
    this.filterModel.pageSize = this.pageSize;
    this.filterModel.sortItems = sortList.NewestCreate;
    this.buildFilterForm();
    // this.GetRestaurants()
    // this.getAll(null);
    this.subscriptions.push(
      this.service.refreshList.subscribe(data => {
        if (data) {
          this.getAll(null);
        }
      })
    )
  }

  ngOnDestroy() {
    this.service.refreshList.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  buildFilterForm() {
    this.filterFormGroup = this.formBuilder.group({
      createdFrom: [null],
      createdTo: [null],
      numberOfItemfrom: [null],
      numberOfItemto: [null],
    });
  }

  GetRestaurantShortDetails(restaurantId: any) {
    this.restaurantService.GetRestaurantShortDetails(restaurantId).subscribe((data: any) => {
      this.restaurantData = data
    })
  }

  getAll(event: any, restId?: any) {
    this.restaurantId = restId
    this.filterModel.restaurantId = this.restaurantId
    this.dataLoading = true;

    if (!event) {
      this.pageIndex = 0;
    }
    if (event && event.pageSize) {
      this.pageIndex = event.pageIndex;
      this.filterModel.pageSize = event.pageSize;
    }
    this.filterModel.pageNumber = this.pageIndex;

    this.service.getAll(this.filterModel).subscribe(
      (data: ListData) => {
        this.dataLoading = false;
        if (data) {
          this.recordsData = data;
          this.restaurantName = data.restaurantName
          this.pageCount = Math.ceil(this.recordsData.totalCount / this.filterModel.pageSize);
        }
      },
      (error: any) => {
        this.recordsData = null;
        this.dataLoading = false;
      });
  }


  makeSearch() {
    if (!this.showSearch) {
      this.showSearch = true; // Show input
    } else {
      if (this.filterModel.searchText) {
        this.getAll(null, this.restaurantId);
      }
    }
  }

  resetSearch() {
    this.filterModel.searchText = '';
    this.getAll(null, this.restaurantId);
  }

  makeFilter() {
    const controls = this.filterFormGroup.controls;
    this.filterModel.createdFrom = controls['createdFrom'].value;
    this.filterModel.createdTo = controls['createdTo'].value;
    this.filterModel.numberOfItemfrom = controls['numberOfItemfrom'].value;
    this.filterModel.numberOfItemto = controls['numberOfItemto'].value;

    this.getAll(null, this.restaurantId);
  }

  clearFilter() {
    this.filterModel = new ListFilter();
    this.filterModel.sortItems = sortList.NewestCreate;
    this.filterModel.pageSize = this.pageSize
    this.getAll(null, this.restaurantId);
    this.filterFormGroup.reset();
  }


  ////////////////////////////////////////////


  // record: Record
  openForm(record: any | null = null) {
    const dialogRef = this.dialog.open(MenuCategoriesFormComponent, {
      width: '50rem',
      data: { record, restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAll(true, this.restaurantId);
      }
    });
  }

  deleteRecord(recordId: string) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        this.service.delete(recordId).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.deletededsuccessfuly'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAll(true, this.restaurantId);
            }
          },
          (error: any) => {
            this.dataLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          });
      }
    });
  }
  GetScreenData() {
    this.getAll(null, this.restaurantId);
    // this.GetRestaurantShortDetails(this.restaurantId);
  }
}
